import { K_RootPrefix } from "../providers/ConfigsDataContextProvider";

// ------   STATIC   ------
export const StepId = {
  APPS: 'apps',
  RELS: 'rels',
  ENVS: 'envs',
  CFGS: 'cfgs'
}
// TODO: come on now.. really - types? todo - re-design to not use types...
export const crumbType_Path = 'path';
export const crumbType_Config = 'config';
// const crumbType_History = 'history';
// const crumbType_Favorite = 'favorite'

export const OrderedSteps = [StepId.APPS, StepId.RELS, StepId.ENVS, StepId.CFGS];
export const getSelectedOrderedSteps = (steps) => OrderedSteps.filter(orderedStep => Boolean(steps[orderedStep]));

export const getStepIndex = (stepName) => OrderedSteps.indexOf(stepName);
const getRelsStepPath = (steps) => `$.rootAccount['${StepId.APPS}']['${steps[StepId.APPS]}']`;
const getEnvsStepPath = (steps) => `$.rootAccount['${StepId.APPS}']['${steps[StepId.APPS]}']['${StepId.RELS}']['${steps[StepId.RELS]}']`;
const getCfgsStepPath = (steps) => `$.rootAccount['${StepId.APPS}']['${steps[StepId.APPS]}']['${StepId.RELS}']['${steps[StepId.RELS]}']['${StepId.ENVS}']['${steps[StepId.ENVS]}']`;
export const sdkParam = (steps) => `['${steps[StepId.APPS]}']['${steps[StepId.RELS]}']['${steps[StepId.ENVS]}']['${steps[StepId.CFGS]}']`;

const getSelectedAppName = (steps) => steps[StepId.APPS];
const getSelectedReleaseName = (steps) => steps[StepId.RELS];
export const getSelectedEnvName = (steps) => steps[StepId.ENVS];
export const selectedConfigBase = (steps) => `$.rootAccount['${StepId.APPS}']['${steps[StepId.APPS]}']['${StepId.RELS}']['${steps[StepId.RELS]}']['${StepId.ENVS}']['${steps[StepId.ENVS]}']['${StepId.CFGS}']['${steps[StepId.CFGS]}']`;
export const getSelectedEnvPath = (steps) => `['${getSelectedAppName(steps)}']['${getSelectedReleaseName(steps)}']['${getSelectedEnvName(steps)}']`;
export const getStepName = (pos) => OrderedSteps.at(pos);

// const isValidStepName = (stepName) => Boolean(stepName) && Boolean(getStepIndex(stepName) >= 0);
// const getStepsWith = (stepName) => isValidStepName(stepName) ?  OrderedSteps.slice(0, getStepIndex(stepName)+1) : [];
//const getActiveSteps = (activeStep) => getStepsWith(activeStep);

export const isConfigStep = (stepName) => stepName === StepId.CFGS;
export const isAppStep = (stepName) => stepName === StepId.APPS;

const SelectorCards = {
  [StepId.APPS]: {title: 'Applications', getPath: () => `$.rootAccount`},
  [StepId.RELS]: {title: 'Releases', getPath: (steps) => getRelsStepPath(steps) },
  [StepId.ENVS]: {title: 'Environments', getPath: (steps) => getEnvsStepPath(steps) },
  [StepId.CFGS]: {title: 'Configurations', getPath: (steps) => getCfgsStepPath(steps) }
}

export const getSetupCard = (stepName) => SelectorCards[stepName];
export const getSetupCardItemsPath = (steps, stepName) => `${getSetupCard(stepName).getPath(steps)}['${stepName}']`;

export const getAppsPath = () => {
  return `${SelectorCards[StepId.APPS].getPath()}['${StepId.APPS}']`;
}



export const getEnvBasePath = (steps) => {
  return SelectorCards[StepId.CFGS].getPath(steps);
}

/**
 * Deletes all steps above the given position (number).
 */
const deleteStepsAbovePos = (steps, pos) => {
  OrderedSteps
  .filter(step => getStepIndex(step) > pos)
  .forEach(stepToDelete => delete steps[stepToDelete]);
}

/**
 * Cuts the steps to only up to the active step.
 * Useful when the user select any previous step.
 */
export const cutSteps = (steps, activeStep) => {
  if (activeStep) {    
    const curPos =  getStepIndex(activeStep);
     if (curPos > -1) {
      deleteStepsAbovePos(steps, curPos);
    }
  }
}

/*
  * Converts a full path string to an object with step-name as keys and the step instance as their values.
  * Example: 
  * Input: "$.rootAccount.apps['my-app']['rels']['v1.0.0']['envs']['dev']"
  * Output: { apps: 'my-app', rels: 'v1.0.0', envs: 'dev' }
  */
export const pathToSteps = (path) => {
  const segments = path.slice(K_RootPrefix.length).match(/\['(.*?)'\]/g)?.map(segment => segment.slice(2, -2)) || [];
  return segments.reduce((acc, curSegment, ix) => {      
    if (ix % 2 === 0 && OrderedSteps.includes(curSegment)) {
      acc.lastKey = curSegment;
    }
    else {
      acc.steps[acc.lastKey] = curSegment;
    }      
    return acc;
  }, { steps: {}, lastKey: null}).steps;
}  


//
// ===  Navigate the Config Wizard Selections  ===
// 
export default function useSelector() {  
//`$.rootAccount.apps['${configSelectedSteps[StepId.APPS]}']`},
//`$.rootAccount.apps['${configSelectedSteps[StepId.APPS]}']['${StepId.RELS}']['${configSelectedSteps[StepId.RELS]}']`},
//`$.rootAccount.apps['${configSelectedSteps[StepId.APPS]}']['${StepId.RELS}']['${configSelectedSteps[StepId.RELS]}']['${StepId.ENVS}']['${configSelectedSteps[StepId.ENVS]}']`},
  return {    
  }
}

  //  const sdkKiponosArg = `['${configSelectedSteps[SelectorConst.APPS]}']['${configSelectedSteps[SelectorConst.RELS]}']['${configSelectedSteps[SelectorConst.ENVS]}']['${configSelectedSteps[SelectorConst.CFGS]}']`;
  //  const envPath       = `['${configSelectedSteps[SelectorConst.APPS]}']['${configSelectedSteps[SelectorConst.RELS]}']['${configSelectedSteps[SelectorConst.ENVS]}']`;
  //  const envName = configSelectedSteps[SelectorConst.ENVS];
  // Cfg Path starts where Env path ends.
  // const cardsComp = SelectorOrder.map(stepName => {
  //   if (SelectorOrder.indexOf(stepName) <= SelectorOrder.indexOf(activeConfigSelector)) {
  //     return <SetupCard cards={SelectorCards} name={stepName} key={stepName}/>
  //   }
  //   else {
  //     return '';
  //   }    
  // });

  // const getStepsBefore = (stepName) => {
  //   return isValidStepName(stepName) ? OrderedSteps.slice(0, getStepIndex(stepName)) : [];
  // }
